// extracted by mini-css-extract-plugin
module.exports = {"marketing-tag":"index_marketing-tag_WpTmm","channel-notes":"index_channel-notes_2AuO9"};